import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, useTheme } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import React, { useMemo, useState } from "react";
import { useTranslate } from "react-admin";

import { InfoBox } from "./InfoBox";
import { SearchableSelect } from "./SearchableSelect";

interface CustomerProductFilterProps {
  allCustomers: string[];
  selectedCustomer:  string | null;
  handleCustomerChange: (value: string | null) => void;
  
  availableProducts: string[];
  selectedProduct: string | null
  handleProductChange: (value: string | null) => void;
}

export const CustomerProductFilter: React.FC<CustomerProductFilterProps> = ({
  allCustomers,
  selectedCustomer,
  handleCustomerChange,
  availableProducts,
  selectedProduct,
  handleProductChange,
}) => {
  const translate = useTranslate();

  return (
    <InfoBox
      title={translate("osfc.storage_ui.customer_filter.places_title")}
      style={{ margin: "15px 0" }}
    >
      {/* Customer Select */}
      <div style={{ marginBottom: "20px" }}>
        <SearchableSelect
          label={translate("osfc.storage_ui.customer_filter.customer")}
          labelId="customer-select-label"
          value={selectedCustomer}
          options={allCustomers}
          onChange={handleCustomerChange}
          placeholder={translate("osfc.storage_ui.customer_filter.search_customers")}
        />
      </div>

      {/* Product Select */}
      <div>
        <SearchableSelect
          label={translate("osfc.storage_ui.customer_filter.product")}
          labelId="product-select-label"
          value={selectedProduct}
          options={availableProducts}
          onChange={handleProductChange}
          disabled={!selectedCustomer}
          placeholder={translate("osfc.storage_ui.customer_filter.search_products")}
        />
      </div>
    </InfoBox>
  );
};
